import React from 'react';
import AppBar from '../../commons/AppBar'
import SpecificComponent from '../../commons/SpecificComponent';
import Ws from '../../providers/Ws';
import { Grid, FormControl, InputLabel, Select, Input, MenuItem, Chip, Button } from '@material-ui/core';
import Utils from '../../providers/Utils';
import AlertDialog from '../../commons/dialogs/AlertDialog';
import FromServer from './FromServer';
import Chart from 'react-google-charts'



export default class RaportComparativProiecte extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            listProjectsAll:[],
            listProjects:[],
            numeProiect:1,
            isOpenAlert:false,
            chartData:[]
        }
    }

    componentDidMount() {
        this.getProiecte()
    }

    getProiecte = async()=>{
      let fs = new FromServer()

      let proiecte = await fs.getProiecte()
        if(proiecte.r){
            this.setState({listProjectsAll:proiecte.c})
        }

    }

    addProiect =(ev)=>{
        let cloneProiecte = [...this.state.listProjectsAll]

            let idx = cloneProiecte.findIndex(i => i.id === ev.target.value)

           

            let projectsToAdd = [...this.state.listProjects]

            projectsToAdd.push(cloneProiecte[idx])

            // console.log('projectsToAdd :', projectsToAdd);
            cloneProiecte.splice(idx,1)
            this.setState({listProjects:projectsToAdd,
                listProjectsAll:cloneProiecte },()=>{
         
            })
    }

    removeFilterProiect = (p) =>{
        let cloneProiecte = [...this.state.listProjects]

        let idx = cloneProiecte.findIndex(i => i.id === p.id)

       

        let projectsToAdd = [...this.state.listProjectsAll]

        projectsToAdd.push(cloneProiecte[idx])

        // console.log('projectsToAdd :', projectsToAdd);
        cloneProiecte.splice(idx,1)
        this.setState({listProjects:cloneProiecte,
                        listProjectsAll:projectsToAdd},()=>{
         
        })
    }


    getRaport = async() =>{
        let fs = new FromServer();

        if(this.state.listProjects.length>=2){

            let rapoarte = []
            let charts = []

            for(let i = 0 , n = this.state.listProjects.length; i<n;i++){
                rapoarte.push(fs.getSituatiiGenerale(this.state.listProjects[i].id))
                charts.push({nume:this.state.listProjects[i].titlu, chartData:[['Proiect', 
                                                                                'Nr. taskuri completate depasite',
                                                                                'Nr. taskuri completate in termen',
                                                                            'Nr. taskuri deschise',
                                                                        'Nr. taskuri deschise depasite',
                                                                    'Nr. taskuri finalizate',
                                                                'Nr. total taskuri',
                                                            'Nr. utilizatori']]})
            }
        //  console.log('rapoarte :', rapoarte);

         let _rapoarte =await Promise.all(rapoarte)

        //  console.log('_rapoarte :', _rapoarte);

     

         for(let i =0, n = _rapoarte.length; i < n; i++){

            // console.log('_rapoarte[i][0] :',_rapoarte[i][0][0]);
            charts[i].chartData.push(['',
                                     _rapoarte[i][0][0].nr_taskuri_completate_depasite,
                                     _rapoarte[i][0][0].nr_taskuri_completate_intermen,
                                     _rapoarte[i][0][0].nr_taskuri_deschise,
                                     _rapoarte[i][0][0].nr_taskuri_deschise_depasite,
                                     _rapoarte[i][0][0].nr_taskuri_finalizate,
                                     _rapoarte[i][0][0].nr_total_taskuri,
                                     _rapoarte[i][0][0].nr_utilizatori])
         }

         this.setState({chartData:charts})
        
        //  console.log('projectReports :', charts);

         

            
        }else{
            this.setState({isOpenAlert:true})
        }
    }
    render() {
        return (
            <div>
                <AppBar history={this.props.history} title={this.dictionary.appBar.drawer.rapoarte} />

                <AlertDialog
                    open={this.state.isOpenAlert}
                    title={'Raportul poate fi executat pe minim 2 proiecte !'}
                    limba={this.dictionary}
                    dialogClose={()=>(this.setState({isOpenAlert:false}))}
                    noButtonDisplay={1}
                    yesFunction={()=>(this.setState({isOpenAlert:false}))}
                    />

                <div className='container'>
                    <h2 className='pm-title'>Raport comparativ proiecte</h2>

                    <Grid container style={{ marginBottom: 50 }}>


                        <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <FormControl className='inputFocus' style={{width:'30%'}} >
                                <InputLabel htmlFor="resursa">{this.dictionary.proiecte.numeProiect}</InputLabel>
                                <Select

                                    value={this.state.numeProiect || ""}
                                    onChange={(ev) => { this.addProiect(ev) }}

                                    input={<Input id="resursa" />}>


                                    {this.state.listProjectsAll.map((t, idx) => {
                                        return <MenuItem value={t.id} key={idx}  > {t.titlu}</MenuItem>

                                    })
                                    }
                                </Select>
                            </FormControl>
                            </Grid>
                            <Grid  item xs={12} sm={12} md={12} lg={12} xl={12} >
                               <h4 style={{ textAlign: 'left' }} className='pm-title'>Raport comparativ pentru:{this.state.listProjects.map((u,idx)=>{
                                   return(
                                    <Chip
                                    key={idx}
                                    style={{backgroundColor:new Utils().culoriProiecte(idx),
                                            color:'white',
                                            marginLeft:5}}
                                    // avatar={<Avatar alt="Natacha" src="/static/images/avatar/1.jpg" />}
                                    label={u.titlu}
                                    onDelete={()=>{this.removeFilterProiect(u)}}
                                    deleteIcon={<i style={{color:'white'}} className='material-icons'>delete</i>}
                                  />
                                   )
                               })}</h4>

                            </Grid>
                            <Grid style={{ textAlign: 'center', marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <Button variant="outlined" onClick={this.getRaport} className='pm-save-button'>
                                Executa
                            </Button>
                        </Grid>

                        </Grid>

                        
               </div>

               <div style={{overflow:'auto', whiteSpace:'nowrap'}}>
               {this.state.chartData.length > 1 &&
                this.state.chartData.map((c,idx)=>{
                    return(
                        <div style={{width:'45%', display:'inline-block', marginRight:20}} key={idx}>
                            <h2 className='pm-title'>{c.nume}</h2>
                            <Chart
                                                width={'100%'}
                                                height={'500px'}
                                                chartType='BarChart'

                                                data={c.chartData
                                                
                                                    }
                                                    options={{
                                                        title:'Raport comparativ proiecte',
                                                    
                                                    }}
                                            
                                            />
                        </div>
                    )
                })
            }
            </div>
                </div>
                );
               }
}